// The sales taxes the company charges (Sales tax, the Overview's tax tiles), in both designs.
import { useQuery } from './ui.tsx';

/**
 * The sales taxes the company charges: the codes of the zone its invoices use, the same signal as
 * Getting started's "Your sales tax" (rs-office1's demo walk). Null while loading; empty when none
 * is set up yet.
 */
export function useSalesTaxCodes(): string[] | null {
  const zones = useQuery<{
    zones: { id: string; components: { code: string }[] }[];
    defaultZoneId: string | null;
  }>('tax.listZones', {});
  if (!zones.data) return null;
  const zone = zones.data.zones.find((z) => z.id === zones.data!.defaultZoneId);
  return zone ? [...new Set(zone.components.map((c) => c.code))] : [];
}
